import { DeleteTravelExpensesRequest } from '../../../lib/types/models/travel-expenses/travel-expenses-comment'
import { IdsInput } from '../../../lib/types/utils'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteTravelExpensesComments(input: DeleteTravelExpensesRequest) {
  const { ids, affectedStaffId } = input
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.affectedStaffs.deleteTravelExpensesComments.url, { affectedStaffId }),
        { ids }
      )
    )
    .delete()
}
